import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { authService } from '../services/authService';
import { maskCPF } from '../utils/security';
import './MockUserSelect.css';

interface MockUser {
  id: number;
  cpf: string;
  name: string;
  email: string;
  phone?: string;
  city?: string;
  state?: string;
}

const MockUserSelect: React.FC = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();
  const [users, setUsers] = useState<MockUser[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Se já estiver autenticado, redirecionar
    if (isAuthenticated) {
      navigate('/');
      return;
    }

    loadMockUsers();
  }, [isAuthenticated, navigate]);

  const loadMockUsers = async () => {
    try {
      const usersList = await authService.getMockUsers();
      setUsers(usersList);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erro ao carregar usuários mock');
    } finally {
      setLoading(false);
    }
  };

  const handleSelectUser = async (userId: number) => {
    try {
      // Usar ID do usuário em vez de CPF para evitar enviar CPF completo
      const response = await authService.mockLogin(userId);
      login(response.access_token, response.user);
      navigate('/', { replace: true });
    } catch (err: any) {
      alert(err.response?.data?.error || 'Erro ao fazer login');
    }
  };

  if (loading) {
    return (
      <div className="mock-select-container">
        <div className="mock-select-card">
          <p>Carregando usuários...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="mock-select-container">
        <div className="mock-select-card">
          <h1>Erro</h1>
          <p className="error-message">{error}</p>
          <button onClick={() => navigate('/login')} className="btn btn-primary">
            Voltar para Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="mock-select-container">
      <div className="mock-select-card">
        <h1>🔐 Login Mock - PetID Brasil</h1>
        <p className="subtitle">Selecione um usuário para testar a aplicação:</p>
        
        {users.length === 0 ? (
          <div className="no-users">
            <p>Nenhum usuário mock encontrado.</p>
            <p>Execute o script de seed para criar usuários mock no banco de dados.</p>
            <button onClick={() => navigate('/login')} className="btn btn-secondary">
              Voltar para Login
            </button>
          </div>
        ) : (
          <div className="users-list">
            {users.map((user) => (
              <div
                key={user.id}
                className="user-card"
                onClick={() => handleSelectUser(user.id)}
              >
                <div className="user-name">{user.name}</div>
                <div className="user-details">
                  <span className="user-cpf">CPF: {maskCPF(user.cpf)}</span>
                  <br />
                  Email: {user.email}
                  {user.city && user.state && (
                    <>
                      <br />
                      {user.city}, {user.state}
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MockUserSelect;
